import React from 'react';
import {isEmpty, max} from 'lodash';
import {formatCentsPrice} from "../utility/cartHelpers";
import {calculateDiscount, getRealUnitPrice} from "../../models/cartItem";

export default function AgentPriceWarning({item, shoppingCart, currentAgent}) {
  if (!currentAgent) return null;

  const {agentUnitPrice, privateCeilingPercent} = item;
  const fullPrice = getRealUnitPrice(item);

  if (isEmpty(privateCeilingPercent) || (agentUnitPrice === null) || isNaN(agentUnitPrice)) {
    return null;
  }

  const maxDiscount = calculateDiscount({
    item, discountPercent: privateCeilingPercent})
  const minimumPrice = fullPrice - maxDiscount;

  if (agentUnitPrice >= minimumPrice) return null;

  return (
    <div className="bg-red-700 text-white p-2 my-2">
      <span className="mx-2 fa fa-exclamation-triangle text-yellow-400"/>
      <span className="font-bold text-yellow-400 mr-2">Agent Warning:</span>
      Unit price of ${formatCentsPrice(agentUnitPrice)} is below acceptable
      minimum of ${formatCentsPrice(minimumPrice)}. Allowed: {privateCeilingPercent}% off.
    </div>
  );
}
